module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-no-ssr/index.js
// module id = 456
// module chunks = 35783957827783